module.exports = __webpack_public_path__ + "assets/images/circle_black.svg?efbc6a673858070f633a50929b9494e5";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/circle_black.svg
// module id = 370
// module chunks = 0